import React from 'react';
import { Empty, Table } from 'antd';
import { useParams } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import moment from 'moment';

const MobileAcceptRejectLogs = ({ data }) => {
    const columns = [
        {
            title: 'Key',
            dataIndex: 'key',
            key: 'key',
            render: (text) => <strong>{text}</strong>,
        },
        {
            title: 'Value',
            dataIndex: 'value',
            key: 'value',
            render: (text) => Array.isArray(text)
                ? text.map((item, index) => <div key={index}>{item}</div>)
                : text || 'N/A',
        },
    ];

    const transformDataForTable = (log) => [
        { key: 'Task', value: log.title || 'N/A' },
        { key: 'Word Count', value: log.word_count || 'N/A' },
        {
            key: 'Order Date',
            value: log.order_date
                ? moment(log.order_date).local().format("DD-MM-YYYY hh:mm A")
                : 'N/A'
        },
        { key: 'Action', value: log.action || 'N/A' },
        { key: 'Accepted By', value: log.accepted_by || 'N/A' },
        {
            key: 'Action Date',
            value: log.action_date
                ? moment(log.action_date).local().format("DD-MM-YYYY hh:mm A")
                : 'N/A'
        },
        { key: 'Status', value: log.status || 'N/A' },
        {
            key: 'Client Deadline',
            value: log.deadline_hard
                ? moment(log.deadline_hard).local().format("DD-MM-YYYY hh:mm A")
                : 'N/A'
        },
        { key: 'Rejected By', value: log.rejected_by || 'N/A' },
        { key: 'Rejection Reason', value: log.rejected_reason || 'N/A' },
    ];


    return (
        <div style={{ backgroundColor: "#f2f6f9", padding: '10px' }}>
            {data && data.length > 0 ? (
                data.map((log, index) => (
                    <Table
                        key={index}
                        columns={columns}
                        dataSource={transformDataForTable(log)}
                        pagination={false}
                        bordered
                        size="small"
                        style={{ marginBottom: '25px', borderRadius: '5px' }}
                        showHeader={false}
                    />
                ))
            ) : (
                <Empty description="No data available" />
            )}
        </div>

    );
};

const AcceptRejectLogs = ({ acceptRejectLogsData }) => {
    const { orderKey } = useParams();
    const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

    const columns = [
        {
            title: 'Order / Date',
            key: 'order_with_date',
            render: (_, record) => {
                const title = record.title || 'N/A';
                const date = record.order_date
                    ? moment(record.order_date).local().format("DD-MM-YYYY hh:mm A")
                    : 'N/A';

                return (
                    <div>
                        <div>{title}</div>
                        <div style={{ color: '#888' }}>{date}</div>
                    </div>
                );
            }
        },
        {
            title: 'Word Count',
            dataIndex: 'word_count',
            key: 'word_count',
            render: (text) => text || 'N/A'
        },
        {
            title: 'Action / Date',
            key: 'action_with_date',
            render: (_, record) => {
                const action = record.action || 'N/A';
                const date = record.action_date
                    ? moment(record.action_date).local().format("DD-MM-YYYY hh:mm A")
                    : 'N/A';

                return (
                    <div>
                        <div>{action}</div>
                        <div style={{ color: '#888' }}>{date}</div>
                    </div>
                );
            }
        },
        {
            title: 'Accepted By',
            dataIndex: 'accepted_by',
            key: 'accepted_by',
            render: (text) => text || 'N/A'
        },
        {
            title: 'Client Deadline',
            dataIndex: 'deadline_hard',
            key: 'deadline_hard',
            render: (text) =>
                text ? moment(text).local().format("DD-MM-YYYY hh:mm A") : 'N/A'
        },
        {
            title: 'Rejected By',
            dataIndex: 'rejected_by',
            key: 'rejected_by',
            render: (text) => text || 'N/A'
        },
        {
            title: 'Rejection Reason',
            dataIndex: 'rejected_reason',
            key: 'rejected_reason',
            render: (text) => text || 'N/A'
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (text) => text || 'N/A'
        },
    ];

    return (
        <div>
            <h3>Accept/Reject Logs - {orderKey}</h3>
            {isMobile ? (
                <MobileAcceptRejectLogs data={acceptRejectLogsData} />
            ) : (
                <Table
                    dataSource={acceptRejectLogsData}
                    columns={columns}
                    pagination={false}
                    bordered
                    scroll={{ y: 350, x: '100%' }}
                />
            )}
        </div>
    );
}

export default AcceptRejectLogs;
